import React from 'react'
import { useChangeFilterValue, useFilterValue } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'

import DateFilter from '../../../components/filter/DateFilter'
import GroupsFilterV2 from '../../groups/filters/GroupsFilterV2'
import ProfilesFilterV2 from '../../profiles/filters/ProfilesFilterV2'
import { useIsMaster } from '@btime/react-session'
import FilterLink from '../../../components/filter/FilterLink'
import ActivatedFilter from '../../../components/filter/ActivatedFilter'

const ShowDeletedFilter = () => {
  const { t } = useTranslation('common')
  const field = 'includeDeleted'
  const showDeleted = useFilterValue(field, false)
  const label = t('showDeleted')
  const valueFormatted = showDeleted ? label : null
  const handleChange = useChangeFilterValue()

  const onClick = () => {
    handleChange(field, !showDeleted)
  }

  return <FilterLink icon={'RiDeleteBin7Line'} label={label} value={valueFormatted} onClick={onClick} />
}

const UserFiltersList = ({ value, onChange, ...props }) => {
  const { t } = useTranslation('common')
  const isMaster = useIsMaster()
  return (
    <>
      <ProfilesFilterV2 {...props} />
      <GroupsFilterV2 {...props} />
      <DateFilter label={t('creationDate')} field="insertedAt" {...props} />
      <ActivatedFilter />

      {isMaster && <ShowDeletedFilter />}
    </>
  )
}

export default UserFiltersList
